// ── FAQ accordion
  function toggleFaq(btn) {
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i) {
      i.classList.remove('open');
      var b = i.querySelector('.faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  // ── Pricing data
  var VARIANT_ID = 50110038474945;
  var plans = {
    monthly: {
      price: '$119', note: 'Billed $119/mo · cancel anytime',
      save: null, cta: 'Join Monthly — $119/mo →',
      nav: 'Join the Community →', selling_plan: 4019486913
    },
    quarterly: {
      price: '$107', note: 'Billed $428/quarter · cancel anytime',
      save: 'Save 10% — $142/yr vs monthly',
      cta: 'Join Quarterly — $428/quarter →',
      nav: 'Join — from $107/mo →', selling_plan: 4034986177
    },
    annual: {
      price: '$95', note: 'Billed $1,143/yr · cancel anytime',
      save: 'Save 20% — $285/yr vs monthly',
      cta: 'Join Annual — $1,143/yr →',
      nav: 'Join — from $95/mo →', selling_plan: 4035018945
    }
  };

  var currentPlan = 'monthly';

  // ── Fallback: submit a real form POST to /cart/add.
  // Used when the AJAX endpoint is blocked (e.g. Cloudflare bot challenge).
  // The full-page navigation lets the browser render any inline challenge UI.
  function submitCartForm(sellingPlanId) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    form.style.display = 'none';
    function addField(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    addField('id', VARIANT_ID);
    addField('quantity', 1);
    if (sellingPlanId) addField('selling_plan', sellingPlanId);
    addField('return_to', '/checkout');
    document.body.appendChild(form);
    form.submit();
  }

  // ── Add to cart via Shopify AJAX then go to checkout.
  // Falls back to a form POST if /cart/add.js is blocked by bot protection.
  function addToCart(planKey) {
    var plan = plans[planKey];
    var btn  = document.getElementById('join-cta');
    var orig = btn.textContent;
    btn.textContent = 'Processing…';
    btn.style.opacity = '0.7';
    btn.style.pointerEvents = 'none';

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: VARIANT_ID, quantity: 1, selling_plan: plan.selling_plan }]
        })
      });
    })
    .then(function(res) {
      if (!res.ok) {
        submitCartForm(plan.selling_plan);
        return null;
      }
      return res.json();
    })
    .then(function(data) {
      if (data === null) return;
      if (data.items || data.id) {
        window.location.href = '/checkout';
      } else {
        throw new Error(data.description || 'Could not add to cart');
      }
    })
    .catch(function(err) {
      console.error('Cart error:', err);
      submitCartForm(plan.selling_plan);
    });
  }

  // ── Switch pricing plan display
  function setPlan(plan) {
    currentPlan = plan;
    var p = plans[plan];

    document.getElementById('price-amount').textContent = p.price;
    document.getElementById('billed-note').textContent  = p.note;

    var badge = document.getElementById('save-badge');
    if (p.save) {
      badge.textContent = '✓ ' + p.save;
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }

    document.getElementById('join-cta').textContent = p.cta;

    var navCta = document.getElementById('nav-cta');
    if (navCta) navCta.textContent = p.nav;

    ['monthly', 'quarterly', 'annual'].forEach(function(k) {
      document.getElementById('cmp-' + k).classList.toggle('current', k === plan);
    });

    document.querySelectorAll('.billing-pill').forEach(function(b) {
      b.classList.toggle('active', b.dataset.plan === plan);
    });

    slidePill(plan);
  }

  // ── Pill slider animation
  function slidePill(plan) {
    var pills     = document.querySelectorAll('.billing-pill');
    var slider    = document.getElementById('pillSlider');
    var container = document.getElementById('billingPills');
    var idx       = ['monthly', 'quarterly', 'annual'].indexOf(plan);
    if (idx < 0 || !pills[idx]) return;
    var pRect = pills[idx].getBoundingClientRect();
    var cRect = container.getBoundingClientRect();
    slider.style.left  = (pRect.left - cRect.left) + 'px';
    slider.style.width = pRect.width + 'px';
  }

  window.addEventListener('load',   function() { slidePill('monthly'); });
  window.addEventListener('resize', function() { slidePill(currentPlan); });

  // ── Hero video: play-button overlay
  (function() {
    document.querySelectorAll('[data-hv-video]').forEach(function(wrap) {
      var video = wrap.querySelector('video');
      var btn   = wrap.querySelector('.hv-play');
      if (!video || !btn) return;
      btn.addEventListener('click', function() {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function(){});
      });
      video.addEventListener('play',  function() { wrap.classList.add('is-playing'); });
      video.addEventListener('pause', function() {
        if (!video.ended && video.currentTime === 0) wrap.classList.remove('is-playing');
      });
      video.addEventListener('ended', function() { wrap.classList.remove('is-playing'); });
    });
  })();